import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'sb-react-intl'

import CalendarItem from './CalendarItem/CalendarItem'

import messages from './messages'
import s from './Calendar.scss'


const months = [
  messages.months.january,
  messages.months.february,
  messages.months.march,
  messages.months.april,
  messages.months.may,
  messages.months.june,
  messages.months.july,
  messages.months.august,
  messages.months.september,
  messages.months.october,
  messages.months.november,
  messages.months.december,
]

class Calendar extends Component {

  static propTypes = {
    className: PropTypes.string,
    initialDate: PropTypes.object,
    onSelect: PropTypes.func.isRequired,
  }

  constructor({ initialDate }) {
    super()

    this.state = {
      selectedDate: null,
      date: initialDate || new Date(),
    }
  }

  onPreviousMonth = () => {
    const { date } = this.state

    const newDate = new Date(date.getFullYear(), date.getMonth() - 1, 1)
    this.setDate(newDate)
  }

  onNextMonth = () => {
    const { date } = this.state

    const newDate = new Date(date.getFullYear(), date.getMonth() + 1, 1)
    this.setDate(newDate)
  }

  setDate = (date) => this.setState({ date })

  handleSelectedDate = (selectedDate) => {
    const { onSelect } = this.props

    this.setState({ selectedDate })

    if (typeof onSelect === 'function') {
      onSelect(selectedDate)
    }
  }

  areDatesEqual(firstDate, secondDate) {
    if (firstDate && secondDate) {
      const firstYear   = firstDate.getFullYear()
      const secondYear  = secondDate.getFullYear()
      const firstMonth  = firstDate.getMonth()
      const secondMonth = secondDate.getMonth()
      const firstDay    = firstDate.getDate()
      const secondDay   = secondDate.getDate()

      return (
        firstYear === secondYear
        && firstMonth === secondMonth
        && firstDay === secondDay
      )
    }

    return false
  }

  isDatePassed(firstDate, secondDate) {
    if (firstDate && secondDate) {
      const firstYear   = firstDate.getFullYear()
      const secondYear  = secondDate.getFullYear()
      const firstMonth  = firstDate.getMonth()
      const secondMonth = secondDate.getMonth()
      const firstDay    = firstDate.getDate()
      const secondDay   = secondDate.getDate()

      return (
        firstYear > secondYear
        || (firstYear === secondYear && firstMonth > secondMonth)
        || (
          firstYear === secondYear
          && firstMonth === secondMonth
          && firstDay > secondDay
        )
      )
    }

    return false
  }

  getDays() {
    const { selectedDate, date: initialDate } = this.state
    const date = new Date(initialDate.getFullYear(), initialDate.getMonth(), 1)
    const dayOfTheWeek = date.getDay()
    const today = new Date()
    const days = []

    // If the day does not start on Monday, you need to move the date <= on Monday in the last month
    if (dayOfTheWeek !== 1) {
      date.setDate(dayOfTheWeek ? date.getDate() - dayOfTheWeek + 1 : date.getDate() - 6)
    }

    // Calendar have 7 days of week & 6 rows => 7x6=42 days
    const daysInCalendar = 42

    for (let i = 0; i < daysInCalendar; i++) {
      days.push({
        key: date.toString(),
        date: date.getDate(),
        initialDate: new Date(date.toString()),
        isToday: this.areDatesEqual(today, date),
        isSelected: this.areDatesEqual(selectedDate, date),
        isDisabled: this.isDatePassed(today, date, false),
        isInCurrentMonth: date.getMonth() === initialDate.getMonth(),
      })

      date.setDate(date.getDate() + 1)
    }

    return days
  }

  renderCalendar() {
    const days = this.getDays()

    return days.map(({ key, date, initialDate, isSelected, isToday, isInCurrentMonth, isDisabled }) => (
      <CalendarItem
        key={key}
        {...{ date, initialDate, isSelected, isToday, isInCurrentMonth, isDisabled }}
        onDateSelect={this.handleSelectedDate}
      />
    ))
  }

  renderDaysTitles() {
    return Object.keys(messages.days).map((name, index) => (
      <FormattedMessage key={index} className={s.dayTitle} tag="div" {...messages.days[name]} />
    ))
  }

  render() {
    const { date } = this.state
    const { className } = this.props

    return (
      <div className={className}>
        <div className={s.head}>
          <div className={s.prev} onClick={this.onPreviousMonth} />
          {date.getFullYear()}
          <FormattedMessage className={s.month} name="component.Calendar" {...months[date.getMonth()]} />
          <div className={s.next} onClick={this.onNextMonth} />
        </div>
        <div className={s.days}>
          {this.renderDaysTitles()}
          {this.renderCalendar()}
        </div>
      </div>
    )
  }
}


export default Calendar
